<template>
  <svg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip_move)">
      <path
          d="M9.36641 7.50157C9.36641 8.53693 8.52716 9.37618 7.4918 9.37618C6.45655 9.37618 5.61719 8.53693 5.61719 7.50157C5.61719 6.46632 6.45655 5.62695 7.4918 5.62695C8.52716 5.62695 9.36641 6.46632 9.36641 7.50157Z"
          fill="currentColor"/>
      <path
          d="M9.99297 10.626H4.99397C4.64969 10.626 4.36914 10.9065 4.36914 11.2508C4.36914 11.3689 4.40038 11.4802 4.46537 11.5895C4.47658 11.6083 4.48905 11.6264 4.50278 11.6433L7.03849 14.8076C7.16355 14.932 7.32476 15 7.49341 15C7.66218 15 7.82339 14.932 7.98461 14.7682L10.484 11.6438C10.4978 11.627 10.5104 11.6083 10.5216 11.5902C10.5866 11.4802 10.6178 11.3689 10.6178 11.2508C10.6178 10.9065 10.3373 10.626 9.99297 10.626Z"
          fill="currentColor"/>
      <path
          d="M4.99397 4.37725H9.99297C10.3373 4.37725 10.6178 4.0967 10.6178 3.75231C10.6178 3.63423 10.5866 3.52302 10.5216 3.41363C10.5104 3.39487 10.4978 3.37679 10.484 3.35997L7.94834 0.195539C7.69845 -0.0518309 7.32476 -0.091877 7.00234 0.235585L4.50278 3.35997C4.48905 3.37679 4.47658 3.39556 4.46537 3.41363C4.40038 3.52302 4.36914 3.63423 4.36914 3.75231C4.36914 4.0967 4.64969 4.37725 4.99397 4.37725Z"
          fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip_move">
        <rect width="15" height="15" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "IconMove"
}
</script>